import { render } from "./EmailSettingsTable.vue?vue&type=template&id=0138d346&scoped=true"
import script from "./EmailSettingsTable.vue?vue&type=script&lang=js"
export * from "./EmailSettingsTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/whisk/whisk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0138d346"]])

export default __exports__